export function initProblemAccordion() {
  const cards = document.querySelectorAll('.problem-card');
  if (!cards.length) return;

  cards.forEach((card, i) => {
    const header = card.querySelector('.problem-row'); // first row = the problem
    if (!header) return;

    // First card stays open; the CSS only reacts to .is-open on mobile.
    if (i === 0) card.classList.add('is-open');

    header.addEventListener('click', () => card.classList.toggle('is-open'));
  });
}
